/* cspell:ignore noninteractive */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex --
   The scrollable <code> is intentionally focusable for keyboard arrow-scroll
   (axe rule: scrollable-region-focusable). */
import cx from "classnames";

import { Copy } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";
import useCopyToClipboard from "hooks/useCopyToClipboard";

import styles from "./styles.module.css";

type CodeSnippetInlineProps = {
  children: string;
  allowCopy?: boolean;
  copyTitle?: string;
  onCopy?: () => void;
  className?: string;
};

const CodeSnippetInline = ({
  children,
  allowCopy = false,
  copyTitle = "Copy",
  onCopy,
  className,
}: CodeSnippetInlineProps) => {
  const handleCopy = useCopyToClipboard(children, onCopy);

  return (
    <span className={cx(styles.snippet, className)}>
      <code className={styles.code} tabIndex={0}>
        {children}
      </code>
      {allowCopy && (
        <ButtonIcon
          className={styles.copy}
          size="small"
          variant="ghost"
          icon={Copy}
          onPress={handleCopy}
        >
          {copyTitle}
        </ButtonIcon>
      )}
    </span>
  );
};

CodeSnippetInline.displayName = "DS.CodeSnippetInline";

export default CodeSnippetInline;
